import AjaxAddToWishlist from 'extensions/AjaxAddToWishlist/AjaxAddToWishlist.js';
import {subscribeToValidatorKey} from 'extensions/global-element-validation-provider';
import 'extensions/multi-system/components/x-multi-system-basket-container';
import 'extensions/multi-system/components/x-multi-system-basket-item';
import 'extensions/quantify/quantify.js';
import ShippingEstimator from 'extensions/shipping-estimator/ShippingEstimator';
import 'extensions/ui-components/x-basket-item';
import 'extensions/ui-components/x-builderset-group';
import 'extensions/ui-components/x-builderset-group-container';
import 'extensions/ui-components/x-builderset-item';
import 'extensions/ui-components/x-default-basket-container';
import 'extensions/ui-components/x-message';
import WarrantyCheckout from 'extensions/warranty-checkout/WarrantyCheckout';
import {PageManager} from 'genesis-packages/core';
import 'helpers/print.scss';
import './BASK.scss';

export default class BASK extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {

		/**
		 * Estimate Shipping
		 */

		const shippingEstimateForm = document.getElementById('js-shipestimate-form');

		if (shippingEstimateForm) {
			// Initialize shipping estimator functionality
			new ShippingEstimator(shippingEstimateForm);
		}

		// Move to Wishlist Forms
		const mpwlForms = document.getElementsByClassName('js-basket-mpwl');

		for (const mpwlForm of mpwlForms) {
			new AjaxAddToWishlist(
				mpwlForm,
				{
					action: 'MPWL',
					submitButtonElements: '.js-basket-mpwl-button'
				},
				() => {
					window.location.href = this.pageContext.Breadcrumbs_Current_Item_Link;
				}
			);
		}

		// Print Basket Summary
		const printTriggers = document.getElementsByClassName('js-print-basket');
		for (const printTrigger of printTriggers) {
			printTrigger.addEventListener('click', (e)=> {
				e.preventDefault();
				window.print();
			});
		}

		/**
		 * Warranty Checkout
		 */
		if (this.pageContext.Warranty_Checkout === 1) {
			new WarrantyCheckout();
		}

		/**
		 * Builder Order Checkout
		 */
		this.validateBuilderOrderCheckout();
	}

	validateBuilderOrderCheckout () {
		const button = document.getElementById('js-builder-order-checkout-button');

		if (button) {
			button.addEventListener('click', (e) => {
				const validator = subscribeToValidatorKey('BUILDER_ORDER_CHECKOUT');
				const results = validator();

				if (results.length > 0) {
					e.preventDefault();

					const [first] = results;
					first()?.reportValidity();
				}
			});
		}
	}

}
